




















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import LeftRight from './LeftRight.vue';
import ListElement from './ListElement.vue';
import { ElementType } from '../../../core/utils';

@Component({
    components: { ListElement, LeftRight }
})
export default class StepperConfig extends Vue {
    @Prop() elements: ElementType[];
    @Prop() disableRight: boolean;
    @Prop() label: string;
    elementSelected: ElementType | null = null;

    get disableLeft(): boolean {
        return this.elementSelected === null;
    }

    handleSelectElement(elementSelected: ElementType): void {
        this.elementSelected = elementSelected;
    }

    @Emit()
    left(elementSelected: ElementType) {
        this.elementSelected = null;
        return elementSelected;
    }

    @Emit()
    right() {}
}
